import React from 'react'

import { Paper, Typography, Box, Divider, Button } from '@material-ui/core'

import * as service from 'service'
import constants from './../../../../constants'
import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'
import SettingsWebhookTable from './components/SettingsWebhookTable'
import SettingsWebhookForm from './components/SettingsWebhookForm'
import { Permitted } from 'components/Permissions'

const SettingsWebhook = () => {
  const snackbar = useSnackbar()
  const [edit, setEdit] = React.useState(false)

  const {
    response: responseUrlNotificationDefaultInvoices,
    isLoading: isLoadingUrlNotificationDefaultInvoices,
    refresh: refreshUrlNotificationDefaultInvoices,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.URL_NOTIFICATION_DEFAULT_INVOICES,
  })

  const {
    response: responseUrlNotificationDefaultContract,
    isLoading: isLoadingUrlNotificationDefaultContract,
    refresh: refreshUrlNotificationDefaultContract,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.URL_NOTIFICATION_DEFAULT_CONTRACTS,
  })

  const isLoading =
    isLoadingUrlNotificationDefaultInvoices ||
    isLoadingUrlNotificationDefaultContract

  const settings = {
    urlNotificationDefaultInvoices:
      responseUrlNotificationDefaultInvoices &&
      responseUrlNotificationDefaultInvoices.data.setting,
    urlNotificationDefaultContract:
      responseUrlNotificationDefaultContract &&
      responseUrlNotificationDefaultContract.data.setting,
  }

  const handleClickButtonEdit = () => {
    setEdit(true)
  }

  const handleClose = () => {
    setEdit(false)
  }

  const handleSubmit = async data => {
    try {
      await Promise.all([
        service.recurrence.settings.update({
          settingId: constants.settings.URL_NOTIFICATION_DEFAULT_INVOICES,
          value: data.urlNotificationDefaultInvoices,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.URL_NOTIFICATION_DEFAULT_CONTRACTS,
          value: data.urlNotificationDefaultContract,
        }),
      ])

      snackbar.open({
        message: 'Configurações de webhook alteradas com sucesso',
        variant: 'success',
      })

      setEdit(false)

      refreshUrlNotificationDefaultInvoices()
      refreshUrlNotificationDefaultContract()
    } catch (error) {
      snackbar.open({
        message: 'Erro ao alterar configurações de webhook',
        variant: 'error',
      })
    }
  }

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Webhooks</Typography>
        <Permitted tag="update_setting">
          {!edit && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleClickButtonEdit}
            >
              Editar
            </Button>
          )}
        </Permitted>
      </Box>

      <Divider />

      {!edit && (
        <SettingsWebhookTable isLoading={isLoading} settings={settings} />
      )}

      {!isLoading && edit && (
        <SettingsWebhookForm
          settings={settings}
          handleClose={handleClose}
          onSubmit={handleSubmit}
        />
      )}
    </Paper>
  )
}

export default SettingsWebhook
